// AI Chat Constants

export const AI_ASSISTANT = {
  name: 'Inny',
  initial: 'I',
  tagline: "Your AI assistant for managing business operations",
};

export const TIME_GREETINGS: Record<string, string[]> = {
  morning: ['Good morning', 'Rise and shine', 'Hello, early bird'],
  afternoon: ['Good afternoon', 'Hello there', 'Hey'],
  evening: ['Good evening', 'Hello', 'Hey there'],
  night: ['Working late?', 'Burning the midnight oil?', 'Hello, night owl'],
};

export const INVITATIONS = [
  "What can I help you with today?",
  "I can help you manage your business.",
  "Ready when you are.",
  "How can I assist you?",
  "What would you like to do?",
];

export const QUICK_SUGGESTIONS = [
  { icon: 'CalendarPlus', text: "Schedule a shift for tomorrow" },
  { icon: 'MessageSquareText', text: "Draft a reply to my latest review" },
  { icon: 'ChartLine', text: "Show me this week's performance" },
];

export const THINKING_PHRASES = [
  'Thinking',
  'Analyzing',
  'Searching',
  'Processing',
  'Looking up',
];

// Typewriter effect settings
export const TYPEWRITER_SPEED_MS = 15;
